<template>
  <router-view :browser="getBrowser()"/>
</template>

<script>

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "App",
  data(){
    return{
      browser:this.getBrowser()
    }
  },
  methods:{
    getBrowser() {
      let UserAgent = navigator.userAgent.toLowerCase();
      console.warn('match',UserAgent.match(/(?:Edge|Edg|EdgiOS|EdgA)\/(\d+)/i))
      if (UserAgent.match(/(?:Edge|Edg|EdgiOS|EdgA)\/(\d+)/i)){
        return "Edge"
      }else if(UserAgent.match(/(?:Firefox|FxiOS)\/(\d+)/i)){
        return 'Firefox'
      } else{
        return "Chrome"
      }
    },
  },
  mounted() {
    new Promise(function (){
      if (window.location.host === 'www.rokit.gg'){
        window.sc_project = 12738507;
        window.sc_invisible=1;
        window.sc_security="2724bcdc";
        window.sc_remove_link=1;
        let secScript = document.createElement("script");
        secScript.setAttribute("type", "text/javascript");
        secScript.setAttribute("src", "https://www.statcounter.com/counter/counter.js");
        secScript.async = true
        document.body.insertBefore(secScript, document.body.lastChild);
      }
    })
  }
}
</script>
<style lang="scss">
#app{
  width: 100%;
  min-height: 100vh;
  position: absolute;
}
body{
  margin: initial;
  font-family: Lato;
  background-color: #1f2427;
  color: #ffffff;
  a:link, a:hover, a:visited, a:active{
    text-decoration:none;
    color: #ffffff;
  }
}
@font-face {
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  src: local("Lato Regular"), local("Lato-Regular"), url(https://fonts.gstatic.com/s/lato/v14/S6uyw4BMUTPHjxAwXiWtFCfQ7A.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF
}

@font-face {
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  src: local("Lato Regular"), local("Lato-Regular"), url(https://fonts.gstatic.com/s/lato/v14/S6uyw4BMUTPHjx4wXiWtFCc.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD
}

@font-face {
  font-family: Lato;
  font-style: normal;
  font-weight: 700;
  src: local("Lato Bold"), local("Lato-Bold"), url(https://fonts.gstatic.com/s/lato/v14/S6u9w4BMUTPHh6UVSwaPGQ3q5d0N7w.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF
}

@font-face {
  font-family: Lato;
  font-style: normal;
  font-weight: 700;
  src: local("Lato Bold"), local("Lato-Bold"), url(https://fonts.gstatic.com/s/lato/v14/S6u9w4BMUTPHh6UVSwiPGQ3q5d0.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD
}

@font-face {
  font-family: Lato;
  font-style: normal;
  font-weight: 900;
  src: local("Lato Black"), local("Lato-Black"), url(https://fonts.gstatic.com/s/lato/v14/S6u9w4BMUTPHh50XSwaPGQ3q5d0N7w.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF
}

@font-face {
  font-family: Lato;
  font-style: normal;
  font-weight: 900;
  src: local("Lato Black"), local("Lato-Black"), url(https://fonts.gstatic.com/s/lato/v14/S6u9w4BMUTPHh50XSwiPGQ3q5d0.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD
}
</style>
